import firebase from 'firebase/app'
import 'firebase/firebase-messaging'


const firebaseConfig = {
    apiKey: "AIzaSyDaqI1O03Gk0OksofN69rbOtcK0qE6yb6w",
    authDomain: "speedfriending-c60f0.firebaseapp.com",
    projectId: "speedfriending-c60f0",
    storageBucket: "speedfriending-c60f0.appspot.com",
    messagingSenderId: "176447893760",
    appId: "1:176447893760:web:7541c96d3542a668ae83e5",
    measurementId: "G-Y2786KW63K"
};
let messaging = null;
try {
    firebase.initializeApp(firebaseConfig);
    messaging = firebase.messaging();
} catch (e) {
    console.log(e);
}

try {
    navigator.serviceWorker.addEventListener('message', event => {
        const notification = event?.data?.notification;
        console.log('Push Notification Received', event, notification);
        const notificationOptions = {
            body: notification.body,
            icon: notification.icon,
            data: {
                click_action: notification.click_action
            }
        };
        const notificationTitle = notification.title;

        try {
            const obj = new Notification(notificationTitle, notificationOptions);
            obj.onclick = (ev) => {
                ev.preventDefault();
                window.open('https://app.speedfriending.com/user', '_blank');
            }
        } catch (e) {
            console.log('new Notification err:', e);
        }
    });
} catch (e) {
    console.log(e);
}

try {
    messaging.onMessage(function ({notification}) {
        console.log('message. onMessage handler (firebase js)', notification);

        // try {
        //     navigator.serviceWorker.register('messaging-sw.js', {scope: "/"});
        // } catch (e) {
        //     console.log(e);
        // }

        const notificationOptions = {
            body: notification.body,
            icon: notification.icon,
            data: {
                click_action: notification.click_action
            }
        };
        const notificationTitle = notification.title;
        const obj = new Notification(notificationTitle, notificationOptions);
        obj.onclick = (ev) => {
            ev.preventDefault();
            window.open(notification.click_action, '_blank');
        }
    })
} catch (e) {
    console.log(e);
}

export default messaging;
